import script from "./StatementInspect.vue?vue&type=script&setup=true&lang=js"
export * from "./StatementInspect.vue?vue&type=script&setup=true&lang=js"

import "./StatementInspect.vue?vue&type=style&index=0&id=22181f32&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22181f32"]])

export default __exports__